import { useEffect } from "react";

import { CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { isUserParticipant, isUserProvider } from "~/utils/keycloakHelpers";
import { routeToErrorPage } from "~/utils/navigationMap";
import { ProtectedRoute, useKeycloak } from "../authorization";
import { DashboardPPT } from "./authorized/dashboard_ppt";
import { DashboardPPTProvider } from "./authorized/dashboard_ppt/DashboardPPTProvider";
import ParticipantSelection from "./authorized/dashboard_staff/ParticipantSelection";
import ProviderHome from "./authorized/provider/ProviderHome";

const Home = () => {
  const keycloak = useKeycloak();

  const navigate = useNavigate();

  const isPPT = isUserParticipant(keycloak);
  const isProvider = isUserProvider(keycloak);

  useEffect(() => {
    if (Object.keys(keycloak).length) {
      if (keycloak.onVerificationCallback) {
        navigate("/complete-registration");
      } else if (!keycloak.authenticated) {
        routeToErrorPage();
      }
    }
  }, [keycloak, navigate]);

  if (!Object.keys(keycloak).length) {
    return (
      <CircularProgress
        size={150}
        sx={{ position: "absolute", justifySelf: "anchor-center", alignSelf: "anchor-center", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      />
    );
  }

  return keycloak.onVerificationCallback || !keycloak.authenticated ? null : (
    <ProtectedRoute>
      {isPPT && (
        <DashboardPPTProvider>
          <DashboardPPT />
        </DashboardPPTProvider>
      )}
      {isProvider && <ProviderHome />}
      {!isPPT && !isProvider && <ParticipantSelection />}
    </ProtectedRoute>
  );
};

export default Home;
